export class LeadOfSourceModel
{
  leadid = 0 ;
  leadname = '' ;
  leadnotes = '' ;

}
